import React from "react";
import { stateToString } from ".";

const ConnectionStatus = ({ status }) => {
  return <p>{stateToString(status)}</p>;
};

export default ConnectionStatus;



// WEBPACK FOOTER //
// ./src/kiosk/ConnectionStatus.jsx